import React, { useState, useLayoutEffect } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import RfqRequestPreviewHeaderPresenter from './RfqRequestPreviewHeaderPresenter';
import ServiceTypeCardPresenter from './ServiceTypeCardPresenter';
import DrawingFileUploadPresenter from './DrawingFileUploadPresenter';
import DrawingFilesPermissionPresenter from './DrawingFilesPermissionPresenter';
import DrawingFilesDetailedInfoPresenter from './DrawingFilesDetailedInfoPresenter';
import ProjectInfoPresenter from './ProjectInfoPresenter';
import FooterBtnPresenter from './FooterBtnPresenter';
import RfqRequestDialogPresenter from './RfqRequestDialogPresenter';
import useQueryString from '@hooks/useQueryString';
import { RequestQueryString } from '@routes/NewRequest/types';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
      padding: '135px 0px 100px 0px',
      [theme.breakpoints.down('xs')]: {
        marginBottom: 89,
        paddingLeft: 16,
        paddingRight: 16
      }
    }
  };
});

const RfqRequestPreviewPresenter: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const {
    query: { serviceType }
  } = useQueryString<RequestQueryString>();

  const onClick = () => {
    setIsOpen(true);
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <RfqRequestPreviewHeaderPresenter />
      <Container className={classes.root}>
        <RfqRequestDialogPresenter
          open={isOpen}
          onClose={() => setIsOpen(false)}
        />
        {!serviceType && <ServiceTypeCardPresenter onClick={onClick} />}
        <DrawingFileUploadPresenter onClick={onClick} />
        <DrawingFilesPermissionPresenter onClick={onClick} />
        <DrawingFilesDetailedInfoPresenter onClick={onClick} />
        <ProjectInfoPresenter onClick={onClick} />
        <FooterBtnPresenter onClick={onClick} />
      </Container>
    </React.Fragment>
  );
};

export default RfqRequestPreviewPresenter;
